/**
 * User API Service
 */

import apiClient from './apiClient';
import {
  UserDTO,
  CreateUserRequest,
  PageResponse,
} from '../types/user.types';

const BASE_PATH = '/v1/users';

class UserService {
  async createUser(request: CreateUserRequest): Promise<UserDTO> {
    const response = await apiClient.post<UserDTO>(BASE_PATH, request);
    return response.data;
  }

  async getUserById(id: string): Promise<UserDTO> {
    const response = await apiClient.get<UserDTO>(`${BASE_PATH}/${id}`);
    return response.data;
  }

  async getUserByUsername(username: string): Promise<UserDTO> {
    const response = await apiClient.get<UserDTO>(`${BASE_PATH}/username/${username}`);
    return response.data;
  }

  async getAllUsers(page: number = 0, size: number = 20): Promise<PageResponse<UserDTO>> {
    const response = await apiClient.get<PageResponse<UserDTO>>(BASE_PATH, {
      params: { page, size, sort: 'createdAt' },
    });
    return response.data;
  }

  async getUsersByRole(role: string): Promise<UserDTO[]> {
    const response = await apiClient.get<UserDTO[]>(`${BASE_PATH}/role/${role}`);
    return response.data;
  }

  async updateUser(id: string, data: Partial<UserDTO>): Promise<UserDTO> {
    const response = await apiClient.put<UserDTO>(`${BASE_PATH}/${id}`, data);
    return response.data;
  }

  async deleteUser(id: string): Promise<void> {
    await apiClient.delete(`${BASE_PATH}/${id}`);
  }
}

export default new UserService();
